import React from "react";
import Box from "@mui/material/Box";

import { useMatchDatesStatusContext } from "../../contexts/MatchDatesStatusContext/context";
import { MATCHING_ROUND_COLORS } from "../MatchingRoundStatus";
import { MATCH_DATES_STATUS_BANNER_ID } from "../MatchDatesStatusBanner/MatchDatesStatusBanner";

export const HeaderSpacing = () => {
  const [bannerHeight, setBannerHeight] = React.useState(0);
  const { status } = useMatchDatesStatusContext();

  React.useEffect(() => {
    if (!status) {
      return;
    }

    const handleResize = () => {
      const banner = document.getElementById(MATCH_DATES_STATUS_BANNER_ID);
      setBannerHeight(banner?.getBoundingClientRect().height || 0);
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [status]);

  return <>{!!status && <Box bgcolor={MATCHING_ROUND_COLORS[status].bg} pt={`${bannerHeight}px`} />}</>;
};
